export class HeatmapResponse {
    status: number;
    message: string;
    data: HeatmapData;
}

export class HeatmapData {
    userId: string;
    mac: string;
    locationComment: string;
    account: string;
    workorder: string;
    location: string;
    timestamp: number;
    uploadTimestamp: number;
    latitude: number;
    longitude: number;
    locationData: any;
    scanType: string;
    locationGroup: string;
    nodeName: string;
    meterType: string;
    fwVersion: string;
    iosVersion: string;
    appVersion: string;
    buildNumber: string;
    status: string;
    elapsedTime: string;
    code: string;
    persistence: string;
    refLevel: string;
    numBins: number;
    cellsPerBin: number;
    bins: number[][];
    startFrequency: number;
    endFrequency: number;
    stepFrequency: number;
}